export enum BackgroundCheckRoleNames {
  APPLICANT = 'APPLICANT',
  REQUESTER = 'REQUESTER',
  SPECTATOR = 'SPECTATOR',
}
